import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { GraduationCap, CircleNotch } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Contraseña actualizada");
      navigate("/login");
    } catch (e) { setErr(apiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <div className="w-full max-w-sm animate-fade-up">
        <Link to="/" className="flex items-center mb-8 justify-center">
          <Logo className="h-9" />
        </Link>
        <h1 className="font-display text-3xl font-800 tracking-tight mb-6">Nueva contraseña</h1>
        {!token ? (
          <p className="text-sm text-destructive">Enlace inválido. Solicita uno nuevo.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label htmlFor="password">Contraseña nueva</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                required minLength={6} data-testid="reset-password" className="mt-1.5" />
            </div>
            {err && <p className="text-sm text-destructive">{err}</p>}
            <Button type="submit" disabled={loading} data-testid="reset-submit"
              className="w-full bg-primary hover:bg-blue-600 text-white">
              {loading ? <CircleNotch className="animate-spin" /> : "Actualizar contraseña"}
            </Button>
          </form>
        )}
      </div>
    </div>
  );
}
